import script from "./content-new.vue?vue&type=script&setup=true&lang=js"
export * from "./content-new.vue?vue&type=script&setup=true&lang=js"

import "./content-new.vue?vue&type=style&index=0&id=70e82125&lang=scss"

const __exports__ = script;

export default __exports__